// extracted by mini-css-extract-plugin
export default {"Container":"Logout_Container__ksZ2q","Heading":"Logout_Heading__t9o6b","LogoutBtn":"Logout_LogoutBtn__rdzb7"};